import axios from '@/plugins/axios';
import { groupBy, map, has } from 'lodash';

export const RULE_TYPE = {
  INPUT: 'Input',
  RADIO: 'Radio'
};

export const RULE_CONTENT_TYPE = {
  IMAGES: 'images',
  RADIO: 'radio',
  RADIO_TEXT: 'radioText',
  TEXT: 'text',
  BUYER_FILE: 'buyerfile',
  SUPPLIER_FILE: 'supplierfile',
  TEXT_DETAIL: 'text-detail'
};

export const BUSI_TYPE = {
  BUSINESS_LICENSE: 'BusinessLicense'
};

export const RULE_EDIT_TYPE = {
  UPLOAD_IMAGE: 'uploadImage',
  SINGLE_CHOICE: 'singleChoice',
  SINGLE_INPUT: 'singleInput',
  ATTACHMENT: 'attachment',
  INFO_DISPLAY: 'infoDisplay',
  PRESET_RULE: 'presetRule'
};

export const PRESET_RULE_ARR = [
  {
    busiType: 'BusinessLicense',
    ruleName: '营业执照',
    content: '上传营业执照扫描件并加盖公章',
    editType: 'uploadImage',
    type: 'images'
  }
];

export function getRuleEditType(ruleContent) {
  let activeName = RULE_EDIT_TYPE.UPLOAD_IMAGE;
  if (ruleContent.length > 0) {
    let type = ruleContent[0]['type'];
    if (has(ruleContent[0], 'busiType')) {
      activeName = RULE_EDIT_TYPE.PRESET_RULE;
    } else {
      switch (type) {
        case RULE_CONTENT_TYPE.IMAGES:
          activeName = RULE_EDIT_TYPE.UPLOAD_IMAGE;
          break;
        case RULE_CONTENT_TYPE.RADIO:
        case RULE_CONTENT_TYPE.RADIO_TEXT:
          activeName = RULE_EDIT_TYPE.SINGLE_CHOICE;
          break;
        case RULE_CONTENT_TYPE.TEXT:
          activeName = RULE_EDIT_TYPE.SINGLE_INPUT;
          break;
        case RULE_CONTENT_TYPE.BUYER_FILE:
        case RULE_CONTENT_TYPE.SUPPLIER_FILE:
          activeName = RULE_EDIT_TYPE.ATTACHMENT;
          break;
        case RULE_CONTENT_TYPE.TEXT_DETAIL:
          activeName = RULE_EDIT_TYPE.INFO_DISPLAY;
          break;
        default:
          activeName = RULE_EDIT_TYPE.UPLOAD_IMAGE;
      }
    }
  }
  return activeName;
}

export function listDigital(params) {
  return axios.get('/ruleDigital/listDigital', { params });
}

export function saveDigital(params) {
  return axios.post('/ruleDigital/saveDigital', {
    typeName: params.typeName,
    ruleName: params.ruleName,
    ruleContent: params.ruleContent,
    ruleType: params.ruleType,
    groupSort: params.groupSort,
    templateId: params.templateId
  });
}

export function editDigital(params) {
  return axios.post('/ruleDigital/editDigital', {
    digitalId: params.digitalId,
    ruleName: params.ruleName,
    ruleContent: params.ruleContent,
    ruleType: params.ruleType
  });
}

export function delDigitalById(digitalId) {
  return axios.post('/ruleDigital/delDigitalById', {
    digitalId
  });
}

export function addRuleType(params) {
  return axios.post('/ruleDigital/addRuleType', params);
}

export function editRuleType(params) {
  return axios.post('/ruleDigital/editRuleType', {
    templateId: params.templateId,
    typeName: params.typeName,
    newTypeName: params.newTypeName
  });
}

export function delRuleType(params) {
  return axios.post('/ruleDigital/delRuleType', {
    templateId: params.templateId,
    typeName: params.typeName
  });
}

export function sortRuleDigital(params) {
  return axios.post('/ruleDigital/sortRuleDigital', params);
}

export function sortRuleDigitalGroup(params) {
  return axios.post('/ruleDigital/sortRuleDigitalGroup', params);
}

export function handleRuleDigitalList(digitalList) {
  // 分组
  let ruleDigitalArrObj = groupBy(digitalList, function(n) {
    return n['groupSort'];
  });
  let ruleDigitalArr = [];
  // 组装
  Object.keys(ruleDigitalArrObj).forEach(function(key, index) {
    let ruleResult = false;
    map(ruleDigitalArrObj[key], function(n) {
      n['index'] = index + 1;
      n['ruleContent'] = JSON.parse(n['ruleContent']);
      ruleResult = n['ruleResult'] === 'true' || n['ruleResult'] === '1';
      return n;
    });
    ruleDigitalArr.push({
      ruleType: ruleDigitalArrObj[key][0]['typeName'],
      ruleItem: ruleDigitalArrObj[key],
      ruleResult: ruleResult,
      templateId: ruleDigitalArrObj[key][0]['templateId'],
      groupSort: key
    });
  });
  return ruleDigitalArr;
}
